/**
 * File theme.js
 *
 * Main theme scripts which will be loaded at the bottom of every page
 *
 * You can import JS modules from NPM by name, and you can also import from
 * `/src/js/modules/` & `/src/js/vendor/` by name as well (no need for the path)
 *
 * Remember that these will load on every page. If you need a page-dependent
 * script, create a separate file in the root of the `/src/js/` folder and
 * enqueue it in `/inc/enqueue.php`.
 *
 * This file has access to a global `config` variable with the contents of your
 * themeconfig.json file in it, plus a few handy things like `themeurl`.
 */


// Remove html element no-js class, add js
document.documentElement.className = document.documentElement.className.replace( /(?:^|\s)no-js(?!\S)/g, '') + ' js';


// Bootstrap
import 'bootstrap';


/**
 * Lazysizes
 *
 * Image optimization with a blur-in transition that speeds up page load
 *
 * Use php function get_lazy_attachment_image() to generate <img> tags
 * compatible with lazysizes
 */
//import 'lazysizes';

import './theme/skip-link-focus-fix.js';


// El Goo Customizations;
(function($){ 

  $(window).load(function() {
    $('.flexslider').flexslider({
      directionNav: false
    });
  });

  let selectInit = false;

  /*
  **
  ** Global Utilities
  **
  */
  function isMobile(){
      return (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)));
  }

  function setCookie(cname, cvalue, expdate) {
      // var d = new Date();
      // d.setTime(d.getTime() + (exdays*24*60*60*1000));
      //var expires = "expires="+ d.toUTCString();
      var expires = "expires="+ expdate;
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(';');
      for(var i = 0; i <ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
              return c.substring(name.length, c.length);
          }
      }
      return "";
  }


  /*
  **
  ** Sitewide Notifications
  **
  */


  let cityNotifyCookie;

  if($('#site-notification').length){
      cityNotifyCookie = $('#site-notification').attr('data-id');
      $('#site-notification a, #site-notification .notify-close i').on('click',closeNotification);
      if(!getCookie(cityNotifyCookie)){
         $('body').addClass('has-notification');
      }
  }

  function closeNotification(evt){
      $('#site-notification').hide();
      $('body').removeClass('has-notification');
      setCookie(cityNotifyCookie,true, $('#site-notification').attr('data-expires'));
  }


  /*
  **
  ** Search Modal
  **
  */
  $('li.search.nav-item .nav-link').on('click', toggleSearchModal);

  function toggleSearchModal(evt){
    $('#search-modal').modal('toggle');
  }




  /*
  **
  ** Select Filter
  **
  */

  $('.select-filter li').on('click', filterOptionClick);

  function filterOptionClick(evt){
      let filter_el = $(this);
      let selectFilter = filter_el.parent().parent().parent().parent();
      $('li',selectFilter).removeClass('active');
      filter_el.addClass('active');
      selectFilter.attr('filter-value',filter_el.attr('filter-data'));
      $('.select-toggle',selectFilter).text(filter_el.text());
      // $('.mobile-toggle',selectFilter).text(filter_el.text());
      if(!isMobile()){
          $('.select-toggle',selectFilter).trigger('click');
          //$('.mobile-toggle',selectFilter).trigger('click');
      } else {
        $('.select-filter').removeClass('expand');
      }
      fetchPosts(filter_el.attr('filter-data'),3);
  }
  $('.select-filter .select-toggle').on('click', selectFilterToggle);

  function selectFilterToggle(evt){
    evt.preventDefault();
    let filter_el = $(evt.currentTarget);
    //$el = $($el.parent());
    filter_el.parent().toggleClass('expand');

    if (filter_el.parent().hasClass('expand')) {
        filter_el.on('mouseleave', function(evt) {
            filter_el.off('mouseleave');
            filter_el.find('.select-toggle').click();
        });
    }
    else {
        filter_el.off('mouseleave');
    }
  }

  // Initialize Select box
  if(!selectInit &&  $('.select-filter').is('*')){
    let default_selection = $('.select-filter li.active');
    default_selection.trigger('click');
    $('.select-filter .select-toggle').trigger('click');
    selectInit = true;
    fetchPosts(default_selection.attr('filter-data'),3)
  }

  
  // Ajax function to fetch posts
  function fetchPosts(post_id,post_max){
    
      $.ajax({
          url: wpvars.ajaxurl,
          type: 'post',
          data: {
              action: 'fetch_post',
              post_max: post_max,
              post_id: post_id
          },
          beforeSend: function() {
            $('.post-grid').removeClass('loaded')
            $('.post-grid .row').html('');
          },
          success: function( html ) {
            $('.post-grid').addClass('loaded')
            $('.post-grid .row').html(html);
          }
      });
  }



})(jQuery);
